import React from 'react';
const MenuSelector = (props) => {
    return (React.createElement("div", { className: "selector-container" }, props.options.map((option, i) => {
        return (React.createElement("button", { className: `selector-button ${option.name === props.default ? 'selected' : ''}`, id: `${props.type}-${i}`, key: i, value: option.value }, option.name));
    })));
};
export default MenuSelector;
//# sourceMappingURL=MenuSelector.js.map